"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeLock = exports.createLock = exports.checkLock = void 0;

var request = function request(method) {
  return function (project, FetchUtils, cfg) {
    return fetch(cfg.api.projectLock(project), {
      method: method,
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(FetchUtils.checkStatus);
  };
};

var checkLock = request('GET');
exports.checkLock = checkLock;
var createLock = request('POST');
exports.createLock = createLock;
var removeLock = request('DELETE');
exports.removeLock = removeLock;


//////////////////
// WEBPACK FOOTER
// ./client/components/project-reset-container/lib/lock-operations.js
// module id = 761
// module chunks = 0